export class Step1 {
    constructor() {}
    intitule = 'stepper.form.simp_re.step1';
    getspan1 = 'form.simp_re.getspan1';
    getidweb = 'form.simp_re.getidweb';
    getdatepublication = 'form.simp_re.getdatepublication';

}
